import { trackEvent } from '@pb/utils'

export const trackSelectPaymentOption = (): any => {
  const trackingData = {
    event_category: 'Club',
    event_type: 'CLUB_MODAL_PAGES',
    event_id: 'H&M x Klarna Payment Options',
    event_label: 'Click on button to open modul',
  }

  trackEvent(trackingData)
}

export const trackReportReturn = (): any => {
  const trackingData = {
    event_category: 'Club',
    event_type: 'CLUB_MODAL_PAGES',
    event_id: 'H&M x Klarna Report Return',
    event_label: 'Click on button to open modul',
  }

  trackEvent(trackingData)
}

export const trackProductCTA = (productArticleId: string): void => {
  const trackingData = {
    event_type: 'PAY_LATER_PDP_CLICK',
    event_category: 'myaccount',
    event_id: 'Pay later product link clicked',
    event_label: productArticleId,
    product_virtual_category: 'PAY_LATER',
  }
  trackEvent(trackingData)
}
